  <app-page-content>
    <ng-container title *ngIf="userName">{{ userName }}</ng-container>
    <ng-container content class="view-user-container">
      <app-view-edit-user
        [userId]="userId"
        [userType]="userType"
        [allowEdit]="allowEdit"
        [isProfile]="false"
        (loadUser)="userName = $event?.name"
      ></app-view-edit-user>
    </ng-container>
  </app-page-content>
